(function () {
    'use strict';

    angular.module("imApp").factory("ediExportService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 1172,
                    parameters: parms || {}
                });
            },
            listEdiDestinations: function (parms) {
                return $ihttp.post({
                    method: 987,
                    parameters: parms || {}
                });
            },
            listExportProcedures: function (parms) {
                return $ihttp.post({
                    method: 891,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
